var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "radio-container-pc"
  }, [_vm.validator && !_vm.isDisabled ? _c('div', {
    staticClass: "validator-line"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.请填写必填项")) + " ")]) : _vm._e(), _vm._l(_vm.chooseItemList, function (item, index) {
    return _c('div', {
      key: index,
      class: ['form-radio-box-pc', _vm.isDisabled ? 'form-radio-box-pc-disabled' : '']
    }, [_c('div', {
      staticClass: "radio-container-pc-icon",
      on: {
        "click": function ($event) {
          return _vm.clickItem(index);
        }
      }
    }, [_c('div', {
      staticClass: "radio-icon"
    }, [_c('img', {
      staticStyle: {
        "width": "20px",
        "height": "20px",
        "vertical-align": "middle"
      },
      attrs: {
        "src": _vm.changeSelectedIcon(item),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "radio-label"
    }, [_vm._v(" " + _vm._s(item) + " ")])])]);
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }